import { TypesPage } from "@context/types/page";
import { GlobalAction } from "@context/types";

export const pageReducer = (state: number, action: GlobalAction) => {
  switch (action.type) {
    case TypesPage.Previous:
      return state - 1;
    case TypesPage.Next:
      return state + 1;
    case TypesPage.Reset:
      return 0;
    default:
      return state;
  }
};
